export default "__VITE_ASSET__DFvwVLcH__"